import { ChartBoxMultipleIcon } from './ChartBoxMultipleIcon';

/**
 * author: Konstantin Saller
 * id F85DED12-7AE9-436D-81BA-DA154B8E2317
 * name chart-box-multiple
 * version: 7.4.47
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/chart-box-multiple.svg
 * tags
 * - Math 
 */
export const ReportBoxMultipleIcon = ChartBoxMultipleIcon;
export default ReportBoxMultipleIcon